import React from 'react';
import {render} from 'react-dom';
const data = [
  { pic: './public/images/c1.png'},
  { pic: './public/images/c3.png'},
  { pic: './public/images/c6.png'},
  { pic: './public/images/c7.png'},
  { pic: './public/images/c2.png'},
  { pic: './public/images/c4.png'},
  { pic: './public/images/c9.png'},
  { pic: './public/images/c8.png'},
];
const Card = ({pic}) => (
  <section className="column small-6 large-3 clients-home-card">
    <article className="card-wrapper clients-home-card__wrapper">
        <img src={pic} className="clients-home-card__image"/>
    </article>
  </section>
)
const Clients = (props) => {
  return(
    <section className="section-background-color">
      <h2 className="text-center">Our Clients</h2>
      <article className="row align-spaced clients-home-card__content">
        {data.map((item, index) =>
          <Card key={index} {...item} />
        )}
      </article>
    </section>
  );
};
export default Clients;



// WEBPACK FOOTER //
// ./src/HomePage/Clients.js